export default {"src":"/_next/static/media/Frame 2147227877.01f5cc35.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};